import React, { useState, useEffect } from 'react';
import { Card, Button, message, Typography, Empty, Spin } from 'antd';
import { EyeOutlined, FolderOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { useProjects } from '../../../hooks/useDataHooks';
import CustomPagination from '../../components/CustomPagination';
import './ProjectManagement.css';
// Removed unused EmptyState import

const { Text, Title } = Typography;

const ProjectsList = () => {
    const [page, setPage] = useState(1);
    const [perPage] = useState(10);
    const history = useHistory();

    const { projects, pagination, loading, error } = useProjects(page, perPage);

    useEffect(() => {
        if (error) {
            message.error('Failed to fetch projects');
        }
    }, [error]);

    const handleViewDetails = (project) => {
        history.push(`/project-management/${project.id}`);
    };

    const handlePageChange = (newPage, newPerPage) => {
        setPage(newPage);
    };

    if (loading && projects.length === 0) {
        return (
            <div className="projects-list">
                <div className="section-header">
                    <Title style={{ marginBottom: 0, fontSize: 24, fontWeight: 600 }} level={1}>Projects</Title>
                </div>
                <div className="projects-grid--cards">
                    {Array.from({ length: 6 }).map((_, index) => (
                        <Card key={`loading-${index}`} loading style={{ height: 180 }} />
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className="projects-list">
            <div className="section-header">
                <Title style={{ fontSize: 20, fontWeight: 600 }} level={1}>Projects</Title>
            </div>
            
            {projects.length === 0 ? (
                <Empty 
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="No projects found"
                />
            ) : (
                <>
                    <div className="projects-grid--cards">
                        {projects.map((project) => (
                            <Card
                                key={project.id}
                                hoverable
                                style={{ height: 200 }}
                                bodyStyle={{ padding: 16, height: 'calc(100% - 48px)' }}
                                actions={[
                                    <Button
                                        key="view"
                                        type="primary"
                                        icon={<EyeOutlined />}
                                        onClick={() => handleViewDetails(project)}
                                        size="small"
                                    >
                                        View Details
                                    </Button>
                                ]}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                        <FolderOutlined style={{ fontSize: 18, color: '#1890ff', marginRight: 8 }} />
                                        <Title level={5} style={{ margin: 0, flex: 1 }} ellipsis={{ rows: 2 }}>
                                            {project.name}
                                        </Title>
                                    </div>
                                    <div style={{ flex: 1, overflow: 'hidden' }}>
                                        <Text type="secondary" style={{ fontSize: 12 }}>
                                            Code: {project.code || 'N/A'}
                                        </Text>
                                        <br />
                                        <Text type="secondary" style={{ fontSize: 12 }}>
                                            Council: {project.procuring_entities?.[0]?.council?.name || 'N/A'}
                                        </Text>
                                        <br />
                                        <Text type="secondary" style={{ fontSize: 12 }}>
                                            Regions: {project.regions?.length || 0}
                                        </Text>
                                    </div>
                                </div>
                            </Card>
                        ))}
                    </div>
                    
                    {pagination && pagination.total > 0 && (
                        <CustomPagination 
                            pagination={pagination}
                            onPageChange={handlePageChange}
                            loading={loading}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default ProjectsList;
